import { useState, useEffect } from 'react';
const useDetectOutsideClick = (initialState, element) => {
    const [isActive, setIsActive] = useState(initialState);
    useEffect(() => {
        const onClick = (handler) => {
            // If the active element exists and is clicked outside of
            if ((element === null || element === void 0 ? void 0 : element.current) && !(element === null || element === void 0 ? void 0 : element.current.contains(handler.target))) {
                setIsActive(false);
            }
        };
        // If the dropdown is active (ie open) then listen for clicks outside
        if (isActive) {
            // MouseEvent
            window.addEventListener('mousedown', onClick);
            // TouchEvent
            window.addEventListener('touchstart', onClick);
        }
        return () => {
            // MouseEvent
            window.addEventListener('mousedown', onClick);
            // TouchEvent
            window.addEventListener('touchstart', onClick);
        };
    }, [isActive, element]);
    return [isActive, setIsActive];
};
export default useDetectOutsideClick;
